/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiScenarioCategory } from './InternalApiScenarioCategory';
import {
    InternalApiScenarioCategoryFromJSON,
    InternalApiScenarioCategoryFromJSONTyped,
    InternalApiScenarioCategoryToJSON,
    InternalApiScenarioCategoryToJSONTyped,
} from './InternalApiScenarioCategory';
import type { InternalApiScenarioStatus } from './InternalApiScenarioStatus';
import {
    InternalApiScenarioStatusFromJSON,
    InternalApiScenarioStatusFromJSONTyped,
    InternalApiScenarioStatusToJSON,
    InternalApiScenarioStatusToJSONTyped,
} from './InternalApiScenarioStatus';
import type { InternalApiScenarioAlertedPersonCategory } from './InternalApiScenarioAlertedPersonCategory';
import {
    InternalApiScenarioAlertedPersonCategoryFromJSON,
    InternalApiScenarioAlertedPersonCategoryFromJSONTyped,
    InternalApiScenarioAlertedPersonCategoryToJSON,
    InternalApiScenarioAlertedPersonCategoryToJSONTyped,
} from './InternalApiScenarioAlertedPersonCategory';
import type { InternalApiScenarioTypeV2 } from './InternalApiScenarioTypeV2';
import {
    InternalApiScenarioTypeV2FromJSON,
    InternalApiScenarioTypeV2FromJSONTyped,
    InternalApiScenarioTypeV2ToJSON,
    InternalApiScenarioTypeV2ToJSONTyped,
} from './InternalApiScenarioTypeV2';
import type { InternalApiScenarioIntervalTimeUnit } from './InternalApiScenarioIntervalTimeUnit';
import {
    InternalApiScenarioIntervalTimeUnitFromJSON,
    InternalApiScenarioIntervalTimeUnitFromJSONTyped,
    InternalApiScenarioIntervalTimeUnitToJSON,
    InternalApiScenarioIntervalTimeUnitToJSONTyped,
} from './InternalApiScenarioIntervalTimeUnit';
import type { InternalApiScenarioTypology } from './InternalApiScenarioTypology';
import {
    InternalApiScenarioTypologyFromJSON,
    InternalApiScenarioTypologyFromJSONTyped,
    InternalApiScenarioTypologyToJSON,
    InternalApiScenarioTypologyToJSONTyped,
} from './InternalApiScenarioTypology';
import type { InternalApiScenarioVersionParameter } from './InternalApiScenarioVersionParameter';
import {
    InternalApiScenarioVersionParameterFromJSON,
    InternalApiScenarioVersionParameterFromJSONTyped,
    InternalApiScenarioVersionParameterToJSON,
    InternalApiScenarioVersionParameterToJSONTyped,
} from './InternalApiScenarioVersionParameter';
import type { InternalApiScenarioEntityType } from './InternalApiScenarioEntityType';
import {
    InternalApiScenarioEntityTypeFromJSON,
    InternalApiScenarioEntityTypeFromJSONTyped,
    InternalApiScenarioEntityTypeToJSON,
    InternalApiScenarioEntityTypeToJSONTyped,
} from './InternalApiScenarioEntityType';
import type { InternalApiScenarioVersionBasic } from './InternalApiScenarioVersionBasic';
import {
    InternalApiScenarioVersionBasicFromJSON,
    InternalApiScenarioVersionBasicFromJSONTyped,
    InternalApiScenarioVersionBasicToJSON,
    InternalApiScenarioVersionBasicToJSONTyped,
} from './InternalApiScenarioVersionBasic';

/**
 * 
 * @export
 * @interface InternalApiScenario
 */
export interface InternalApiScenario {
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenario
     */
    id: string;
    /**
     * 
     * @type {InternalApiScenarioEntityType}
     * @memberof InternalApiScenario
     */
    entityType: InternalApiScenarioEntityType;
    /**
     * 
     * @type {InternalApiScenarioTypeV2}
     * @memberof InternalApiScenario
     */
    type: InternalApiScenarioTypeV2;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenario
     */
    name: string;
    /**
     * 
     * @type {InternalApiScenarioStatus}
     * @memberof InternalApiScenario
     */
    status: InternalApiScenarioStatus;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenario
     */
    libraryScenarioHandle?: string;
    /**
     * 
     * @type {InternalApiScenarioCategory}
     * @memberof InternalApiScenario
     */
    category?: InternalApiScenarioCategory;
    /**
     * 
     * @type {InternalApiScenarioTypology}
     * @memberof InternalApiScenario
     */
    typology?: InternalApiScenarioTypology;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenario
     */
    internalId?: string;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiScenario
     */
    updatedTime: Date;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenario
     */
    currentVersionLogic?: string;
    /**
     * 
     * @type {Array<InternalApiScenarioVersionParameter>}
     * @memberof InternalApiScenario
     */
    currentVersionParameters?: Array<InternalApiScenarioVersionParameter>;
    /**
     * 
     * @type {InternalApiScenarioAlertedPersonCategory}
     * @memberof InternalApiScenario
     */
    alertedPersonCategory: InternalApiScenarioAlertedPersonCategory;
    /**
     * 
     * @type {number}
     * @memberof InternalApiScenario
     */
    interval?: number;
    /**
     * 
     * @type {InternalApiScenarioIntervalTimeUnit}
     * @memberof InternalApiScenario
     */
    intervalTimeUnit?: InternalApiScenarioIntervalTimeUnit;
    /**
     * 
     * @type {number}
     * @memberof InternalApiScenario
     */
    alertingInterval?: number;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiScenario
     */
    startTime?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiScenario
     */
    deletable: boolean;
    /**
     * 
     * @type {Array<InternalApiScenarioVersionBasic>}
     * @memberof InternalApiScenario
     */
    versions: Array<InternalApiScenarioVersionBasic>;
}



/**
 * Check if a given object implements the InternalApiScenario interface.
 */
export function instanceOfInternalApiScenario(value: object): value is InternalApiScenario {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('updatedTime' in value) || value['updatedTime'] === undefined) return false;
    if (!('alertedPersonCategory' in value) || value['alertedPersonCategory'] === undefined) return false;
    if (!('deletable' in value) || value['deletable'] === undefined) return false;
    if (!('versions' in value) || value['versions'] === undefined) return false;
    return true;
}

export function InternalApiScenarioFromJSON(json: any): InternalApiScenario {
    return InternalApiScenarioFromJSONTyped(json, false);
}

export function InternalApiScenarioFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScenario {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'entityType': InternalApiScenarioEntityTypeFromJSON(json['entityType']),
        'type': InternalApiScenarioTypeV2FromJSON(json['type']),
        'name': json['name'],
        'status': InternalApiScenarioStatusFromJSON(json['status']),
        'libraryScenarioHandle': json['libraryScenarioHandle'] == null ? undefined : json['libraryScenarioHandle'],
        'category': json['category'] == null ? undefined : InternalApiScenarioCategoryFromJSON(json['category']),
        'typology': json['typology'] == null ? undefined : InternalApiScenarioTypologyFromJSON(json['typology']),
        'internalId': json['internalId'] == null ? undefined : json['internalId'],
        'updatedTime': (new Date(json['updatedTime'])),
        'currentVersionLogic': json['currentVersionLogic'] == null ? undefined : json['currentVersionLogic'],
        'currentVersionParameters': json['currentVersionParameters'] == null ? undefined : ((json['currentVersionParameters'] as Array<any>).map(InternalApiScenarioVersionParameterFromJSON)),
        'alertedPersonCategory': InternalApiScenarioAlertedPersonCategoryFromJSON(json['alertedPersonCategory']),
        'interval': json['interval'] == null ? undefined : json['interval'],
        'intervalTimeUnit': json['intervalTimeUnit'] == null ? undefined : InternalApiScenarioIntervalTimeUnitFromJSON(json['intervalTimeUnit']),
        'alertingInterval': json['alertingInterval'] == null ? undefined : json['alertingInterval'],
        'startTime': json['startTime'] == null ? undefined : (new Date(json['startTime'])),
        'deletable': json['deletable'],
        'versions': ((json['versions'] as Array<any>).map(InternalApiScenarioVersionBasicFromJSON)),
    };
}

export function InternalApiScenarioToJSON(json: any): InternalApiScenario {
    return InternalApiScenarioToJSONTyped(json, false);
}

export function InternalApiScenarioToJSONTyped(value?: InternalApiScenario | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'entityType': InternalApiScenarioEntityTypeToJSON(value['entityType']),
        'type': InternalApiScenarioTypeV2ToJSON(value['type']),
        'name': value['name'],
        'status': InternalApiScenarioStatusToJSON(value['status']),
        'libraryScenarioHandle': value['libraryScenarioHandle'],
        'category': InternalApiScenarioCategoryToJSON(value['category']),
        'typology': InternalApiScenarioTypologyToJSON(value['typology']),
        'internalId': value['internalId'],
        'updatedTime': value['updatedTime'].toISOString(),
        'currentVersionLogic': value['currentVersionLogic'],
        'currentVersionParameters': value['currentVersionParameters'] == null ? undefined : ((value['currentVersionParameters'] as Array<any>).map(InternalApiScenarioVersionParameterToJSON)),
        'alertedPersonCategory': InternalApiScenarioAlertedPersonCategoryToJSON(value['alertedPersonCategory']),
        'interval': value['interval'],
        'intervalTimeUnit': InternalApiScenarioIntervalTimeUnitToJSON(value['intervalTimeUnit']),
        'alertingInterval': value['alertingInterval'],
        'startTime': value['startTime'] == null ? value['startTime'] : value['startTime'].toISOString(),
        'deletable': value['deletable'],
        'versions': ((value['versions'] as Array<any>).map(InternalApiScenarioVersionBasicToJSON)),
    };
}

